import { Component, OnInit } from '@angular/core';
import { RedireccionService } from '../../services/redireccion/redireccion.service';
import { RedireccionMenu } from '../../models/menu/redireccion-menu.class';
import { Configuracion } from '../../contants/configuracion.constant';
import { OpcionVentana } from '../../contants/opcion-ventana.constant';
import { AgenteService } from '../../services/agente/agente.service';
import { MensajeSnackBarService } from '../../services/mensaje-snack-bar/mensaje-snack-bar.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  menu: any;
  constructor(private redireccionService: RedireccionService, private agenteService: AgenteService,
    private mensajeSnackBarService: MensajeSnackBarService) { }

  ngOnInit() {
  }


  ingresoClientes() {
    if (this.agenteService.habilitarOpcionesAgente()) {
      this.redireccionService.ejecutarRedireccion(new RedireccionMenu(Configuracion.REDIRECCION_COTIZADOR_NUEVO_MIS_CLIENTES,
        true, false, OpcionVentana.REDIRECCION_DIRECTA_COTIZADOR_PA, '', '', ''));
    } else {
      this.mostrarMensajeAccionUsuario();
    }
  }

  ingresoMisNegocios() {
    if (this.agenteService.habilitarOpcionesAgente()) {
      this.redireccionService.ejecutarRedireccion(new RedireccionMenu(Configuracion.REDIRECCION_COTIZADOR_NUEVO_MIS_NEGOCIOS,
        true, false, OpcionVentana.REDIRECCION_DIRECTA_COTIZADOR_PA, '', '', ''));
    } else {
      this.mostrarMensajeAccionUsuario();
    }

  }


  mostrarMensajeAccionUsuario() {
    if (this.agenteService.getAgente() !== null) {
      this.mensajeSnackBarService.mostrarMensaje(this.agenteService.getAgente().getRestriccionSeleccionAgente());
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts